import {delete_} from "../../../helper/request";

export const deleteFile = file => delete_(`/api/files/${file.id}/`)
